import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDL3INSIDE', label: 'Three Inside Up/Down', lookback: 12 })
